import { useContext, useEffect } from 'react'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

const useCustomerNotification = () => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)

  useEffect(() => {
    if (!rmaInfo?.orderInfo?.notificationLanguage) {
      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderInfo: {
          ...rmaInfo.orderInfo,
          notificationLanguage: rmaInfo?.merchantInfo?.default_language,
        },
      }))
    }
  }, [rmaInfo.merchantInfo.default_language, rmaInfo?.orderInfo?.notificationLanguage, setRmaInfo])

  const handleLanguageChange = language => {
    setRmaInfo(rmaInfo => ({
      ...rmaInfo,
      orderInfo: {
        ...rmaInfo.orderInfo,
        notificationLanguage: language,
      },
    }))
  }
  const handleSendCustomerNotificationChange = sendNotification => {
    setRmaInfo(rmaInfo => ({
      ...rmaInfo,
      orderInfo: {
        ...rmaInfo.orderInfo,
        sendCustomerNotification: sendNotification,
      },
    }))
  }

  return {
    handleLanguageChange,
    handleSendCustomerNotificationChange,
    selectedLanguage: rmaInfo?.orderInfo?.notificationLanguage,
    supportedLanguages: rmaInfo?.merchantInfo?.supported_languages,
    sendCustomerNotification: rmaInfo?.orderInfo?.sendCustomerNotification,
  }
}

export default useCustomerNotification
